
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import Popup from "../../../../../shared/components/ui/popup/Popup";
import ContentsPopup from "../../../../../shared/components/ui/popup/contentPopup/ContentPopup";
import HeaderPopup from "../../../../../shared/components/ui/popup/headerPopup/HeaderPopup";
import AssignWidgetImg from "../../../../../assests/assignStudyGroup/assignWidget.png"
import FooterPopup from "../../../../../shared/components/ui/popup/footerPopup.js/FooterPopup";
import pathRouts from "../../../../../shared/enums/pathRoute";
import classes from "./AssignStudyGroupPopup.module.css";

const AssignStudyGroupPopup = ({ onClose }) => {

    const navigate = useNavigate()
    const { texts } = useSelector((state) => state.translate);
    
    const onClick = () => {
        navigate(`/${pathRouts.MYLEARNING}/${pathRouts.ASSIGNSTUDYGTOUP}`);
        onClose()
    }

    return (
        <Popup close={onClose} title={texts.notice} dropClass={classes.BackdropPopupClass} dropClassClose={classes.DropClassClose} >
            <HeaderPopup className={classes.HeaderPopup}>
                <p className={classes.Title}>{texts.notice}</p>
            </HeaderPopup>
            <ContentsPopup className={classes.Content}>
                <p className={classes.Text}>{texts.assignSyudyGroupTextPopup1}</p>
                <p className={classes.Text}>{texts.assignSyudyGroupTextPopup2}</p>
                <div className={classes.WidgetImg}>
                    <div className={classes.WidgetImgPrs}>
                        <p className={classes.TitelImg}>{texts.assignWidgetTeacher}</p>
                        <img src={AssignWidgetImg} alt={texts.assignStudyGroup} className={classes.AssignImg} />
                    </div>
                    <p className={classes.TextImg}>{texts.assignSyudyGroupTextPopup3}</p>
                </div>
            </ContentsPopup>
            <FooterPopup next={onClick} nextText={texts.toAssignStudyGroup} classNameNext={classes.assignBtn} />
        </Popup >
    )
}
export default AssignStudyGroupPopup;
